import React from 'react';

import Header from './partials/header/Header';
import Service from './partials/service/Service';
import RegisterForm from './partials/register-form/RegisterForm';
import Footer from './partials/footer/Footer';

import * as css from './css/register';

const Register = () => {
    return (
        <css.Register>
            <css.BgImg src={require('./img/bg.png')}/>
            <css.Header as={Header}/>
            <css.Content>
                <css.Service as={Service}/>
                <css.RegisterForm as={RegisterForm}/>
            </css.Content>
            <css.Footer as={Footer}/>
        </css.Register>
    );
}

export default Register;
